import { inject, Injectable } from '@angular/core';
import { AuthFacade } from '@p2p/auth/domain';

@Injectable()
export class AuthApiService {
    private readonly authFacade = inject(AuthFacade);

    isAuthenticated$ = this.authFacade.isAuthenticated$;
    account$ = this.authFacade.account$;

    checkAuthentication() {
        this.authFacade.checkAuthentication();
    }

    logout(url: string): void {
        this.authFacade.logout(url);
    }
}
